export const heroData = {
  title: "发现精彩 尽在快猫",
  subtitle: "海量优质短视频，随时随地刷不停",
  description: "快猫短视频——国内领先的短视频内容平台，汇聚搞笑、美食、音乐、游戏、科技、生活等全品类内容。每日更新百万优质视频，智能推荐算法为你精准匹配兴趣内容。",
  downloadButtons: [
    { label: "iOS 下载", icon: "ri-apple-fill", href: "#download" },
    { label: "Android 下载", icon: "ri-android-fill", href: "#download" },
    { label: "Web 端体验", icon: "ri-computer-line", href: "#download" },
  ],
  stats: [
    { value: "3.2亿+", label: "累计用户" },
    { value: "500万+", label: "日活跃创作者" },
    { value: "1亿+", label: "日均视频播放" },
    { value: "99.9%", label: "服务可用率" },
  ],
};

export const features = [
  {
    id: 1,
    title: "智能推荐",
    description: "基于深度学习算法的个性化推荐引擎，精准匹配你的兴趣偏好，越刷越懂你。",
    icon: "ri-brain-line",
  },
  {
    id: 2,
    title: "高清流畅",
    description: "支持4K超清画质播放，自研编解码技术确保低延迟、高流畅的极致观看体验。",
    icon: "ri-4k-line",
  },
  {
    id: 3,
    title: "安全可靠",
    description: "多层内容审核机制，AI+人工双重保障，打造绿色健康的内容生态环境。",
    icon: "ri-shield-check-line",
  },
  {
    id: 4,
    title: "创作者赋能",
    description: "完善的创作者扶持计划，从流量扶持到商业变现，全方位助力内容创作。",
    icon: "ri-rocket-2-line",
  },
  {
    id: 5,
    title: "互动社区",
    description: "弹幕、评论、点赞、分享，丰富的社交互动功能让观看更有乐趣。",
    icon: "ri-chat-smile-2-line",
  },
  {
    id: 6,
    title: "离线观看",
    description: "支持视频离线缓存，无网络环境也能畅享精彩内容，随时随地想看就看。",
    icon: "ri-download-cloud-2-line",
  },
];

export const categories = [
  { id: 1, name: "搞笑", slug: "funny", icon: "ri-emotion-laugh-line", count: "2.3万", color: "bg-primary-100 text-primary-700" },
  { id: 2, name: "美食", slug: "food", icon: "ri-restaurant-line", count: "1.8万", color: "bg-accent-100 text-accent-700" },
  { id: 3, name: "音乐", slug: "music", icon: "ri-music-2-line", count: "3.1万", color: "bg-secondary-100 text-secondary-800" },
  { id: 4, name: "游戏", slug: "game", icon: "ri-gamepad-line", count: "2.7万", color: "bg-primary-100 text-primary-700" },
  { id: 5, name: "科技", slug: "tech", icon: "ri-cpu-line", count: "1.2万", color: "bg-accent-100 text-accent-700" },
  { id: 6, name: "生活", slug: "lifestyle", icon: "ri-home-heart-line", count: "4.5万", color: "bg-secondary-100 text-secondary-800" },
  { id: 7, name: "运动", slug: "sports", icon: "ri-run-line", count: "1.6万", color: "bg-primary-100 text-primary-700" },
  { id: 8, name: "知识", slug: "knowledge", icon: "ri-book-open-line", count: "2.0万", color: "bg-accent-100 text-accent-700" },
  { id: 9, name: "时尚", slug: "fashion", icon: "ri-t-shirt-line", count: "1.9万", color: "bg-secondary-100 text-secondary-800" },
  { id: 10, name: "宠物", slug: "pet", icon: "ri-heart-pulse-line", count: "1.4万", color: "bg-primary-100 text-primary-700" },
  { id: 11, name: "旅行", slug: "travel", icon: "ri-earth-line", count: "0.8万", color: "bg-accent-100 text-accent-700" },
  { id: 12, name: "影视", slug: "movie", icon: "ri-film-line", count: "2.5万", color: "bg-secondary-100 text-secondary-800" },
];

export const downloadSection = {
  title: "立即下载快猫 App",
  subtitle: "扫码下载或选择你的设备，开启精彩短视频之旅",
  features: [
    "高清流畅播放体验",
    "个性化智能推荐",
    "离线缓存随时观看",
    "海量正版内容库",
  ],
};

export const creatorSection = {
  title: "成为快猫创作者",
  subtitle: "加入快猫创作者生态，让你的才华被世界看见",
  benefits: [
    { title: "流量扶持", description: "新创作者专属流量池，优质内容获得更多曝光机会", icon: "ri-flashlight-line" },
    { title: "商业变现", description: "多元变现方式：广告分成、直播打赏、品牌合作、电商带货", icon: "ri-money-dollar-circle-line" },
    { title: "创作工具", description: "免费专业级视频编辑工具，AI辅助创作，一键生成精彩内容", icon: "ri-tools-line" },
    { title: "成长体系", description: "完善的创作者等级体系，从新手到达人，每一步都有明确指引", icon: "ri-line-chart-line" },
  ],
};

export const faqs = [
  {
    id: 1,
    question: "快猫短视频是免费的吗？",
    answer: "快猫短视频基础功能完全免费，用户可以免费观看所有视频内容。我们同时提供快猫会员服务，会员可享受去广告、高清画质、专属标识等增值权益。",
  },
  {
    id: 2,
    question: "如何在快猫上注册账号？",
    answer: "您可以通过手机号、微信或QQ账号一键注册登录快猫。下载快猫App后，点击「我的」-「立即登录」，选择您喜欢的注册方式，按照提示完成注册即可。",
  },
  {
    id: 3,
    question: "快猫会员有哪些权益？",
    answer: "快猫会员享有多项专属权益：无广告纯净体验、4K超清画质播放、专属会员标识、优先客服响应、每月会员专属福利活动等。会员分为月度、季度和年度三种方案。",
  },
  {
    id: 4,
    question: "如何成为快猫创作者？",
    answer: "在快猫App中进入「创作者中心」，完成实名认证后即可开通创作权限。我们为新创作者提供专属指导教程和流量扶持，帮助您快速成长。",
  },
  {
    id: 5,
    question: "快猫的内容审核标准是什么？",
    answer: "快猫严格遵循国家法律法规和社区规范，采用AI智能审核+人工复审的双重保障机制，确保平台内容的健康、安全、优质。我们坚决抵制低俗、暴力、侵权等违规内容。",
  },
  {
    id: 6,
    question: "视频可以离线下载吗？",
    answer: "当然可以！快猫App支持视频离线缓存功能，您可以在Wi-Fi环境下提前下载喜欢的视频，随时随地无网络也能观看。部分版权保护内容可能不支持下载。",
  },
];